<template>
  <div v-if="isUseCoupon && selectedCoupon.type == 'subscription'">
    <MbTermsUrl url="https://www.emot.jp/romancecar_passport_policy.html" />
    <MFITTTermsUrl url="https://www.emot.jp/romancecar_policy.html" />
  </div>
  <MbTermsUrl v-else url="https://www.emot.jp/romancecar_policy.html" />
</template>
<script>
import { useStore } from "vuex";

export default {
  name: "MFITTTermsButtons",
  setup() {
    const store = useStore();

    const selectedCoupon = store.getters["MFITT/selectedCoupon"];
    const isUseCoupon = selectedCoupon != null;

    return {
      selectedCoupon,
      isUseCoupon,
    };
  },
};
</script>
